import Bowser from "bowser";
const browser = Bowser.getParser(navigator.userAgent);
// 获得系统版本（PC-0，iOS-1，Android-2）
export const getSystem = () => {
  const os = getOS();
  if (os === "iOS") {
    return "iOS";
  } else if (os === "Android") {
    return "Android";
    // 尽管除了iOS和Android，还有其他的移动端系统，比如塞班。由于用户量较少，就将其粗暴分类为PC吧
  } else {
    return "PC";
  }
};
// 手机格式校验
export const PhoneCheck = (phone, areacode) => {
  const validateFormat = (pattern) => {
    return phone.match(pattern);
  };

  switch (areacode) {
    case "886": // 臺灣 09 開頭 10位數字
      var patt1 = /^(\+886\s)?[0]{0,1}[9]{1}\d{8}$/;
      break;
    case "852": // 香港 5、6、9 開頭 8位數字
      var patt2 = /^(\+852\s)?[569]{1}\d{7}$/;
      break;
    case "853": // 澳門 6 開頭 8位數字
      var patt3 = /^(\+853\s)?[6]\d{7}$/;
      break;
    default:
      // 格式錯誤
      return false;
  }

  const isValidFormat = validateFormat(patt1 || patt2 || patt3);

  if (isValidFormat) {
    // 格式正確
    return true;
  } else {
    // 格式錯誤
    return false;
  }
};

import { xhSet, xhGet } from "./xhCookie";
// 判断是否首次进入页面
// 0为假 1为真
export const firstPage = () => {
  if (!xhGet("XH-WEB")?.isRefresh) {
    // 首次进入
    xhSet("XH-WEB", { isRefresh: 1 });
    return true;
  } else if (xhGet("XH-WEB")?.isRefresh == 1) {
    // 刷新页面，非首次进入
    xhSet("XH-WEB", { isRefresh: 0 });
    return false;
  }
};

import qs from "qs";
// 解析URL參數
export const parseUrl = (link) => {
  const url = decodeURI(link);
  const index = url.indexOf("?");
  if (index >= 0) {
    const query = url.slice(index + 1);
    return qs.parse(query);
  } else {
    return {};
  }
};

export const getOS = () => {
  if (/(HarmonyOS|OpenHarmony|ArkWeb)/.test(navigator.userAgent)) {
    return "HarmonyOS";
  }
  return browser.getOSName();
}

export const deviceType = () => {
  const platformType = browser.getPlatformType();
  if (
    platformType === "tablet" ||
    platformType === "mobile" ||
    platformType === "bot" // 机器人 姑且将其分类为MOBILE吧
  ) {
    return "wap";
  } else {
    return "pc";
  }
};

export const Storage = {
  set: (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
  },
  get: (key) => {
    return JSON.parse(localStorage.getItem(key));
  },
};

// 删除接口错误提示括号内容数字
export const removeBracketContent = (str) => {
  return str.replace(/\[.*?\]/g, "");
};

export const bottomScroll = () => {
  var windowHeight = window.innerHeight;
  var body = document.body;
  var html = document.documentElement;
  var documentHeight = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  );
  var scrollableDistance = documentHeight - windowHeight;
  var scrolledDistance =
    window.pageYOffset ||
    (document.documentElement || document.body.parentNode || document.body)
      .scrollTop;

  if (scrollableDistance - scrolledDistance <= 1) {
    return true;
  }
};

import useClipboard from "vue-clipboard3";
const { toClipboard } = useClipboard();
// 复制文本
export const copy = async (val, hint, options = { showSuccess: true }) => {
  try {
    if (val) {
      await toClipboard(val);
    }
    if (options.showSuccess) {
      ElMessage({
        message: hint ? hint : "복사 성공",
        center: true,
        offset: 200,
        type: "success",
      });
    }
    return true;
  } catch (e) {
    ElMessage({
      message: "복사 실패, 수동 복사를 시도해 주세요",
      center: true,
      offset: 200,
      type: "error",
    });
    return false;
  }
};

// 敬请期待
import { ElMessage } from "element-plus";
export const Expect = (link, text = "많이 기대해주세요!") => {
  if (link) {
    window.open(link, "_blank");
    return true
  } else {
    ElMessage({
      message: text,
      center: true,
      offset: 200,
      type: "success",
    });
    return false
  }
};

export const scrollToSpecificHeight = (topValue) => {
  window.scrollTo({
    top: topValue,
    behavior: "smooth",
  });
};

// 去除对象中字符串值的前后空格
export const trimParams = (params) => {
  if (typeof params === "string") {
    return params.trim();
  } else if (Array.isArray(params)) {
    return params.map((item) => trimParams(item));
  } else if (typeof params === "object" && params !== null) {
    return Object.keys(params).reduce((acc, key) => {
      acc[key] = trimParams(params[key]);
      return acc;
    }, {});
  }
  return params;
};

export const getEquipment = (val) => {
  let type;
  if (val == 0) {
    if (deviceType() === "pc") {
      type = "1";
    } else {
      type = "2";
    }
  }
  if (val == 1) {
    if (getSystem() === "Android") type = "1";
    if (getSystem() === "iOS") type = "2";
    if (getSystem() === "PC") type = "3";
  }
  return type;
};

// 浏览器语言 默认英语
export const lang = () => {
  const primaryLanguage = (
    navigator.language ||
    navigator.browserLanguage ||
    navigator.userLanguage
  ).toLowerCase();
  if (primaryLanguage.startsWith("zh")) {
    return "cn";
  } else if (primaryLanguage.startsWith("th")) {
    return "th";
  } else {
    return "en";
  }
};
